import { render, staticRenderFns } from "./UserProgressTracker.vue?vue&type=template&id=722b9e48&scoped=true"
import script from "./UserProgressTracker.vue?vue&type=script&lang=js"
export * from "./UserProgressTracker.vue?vue&type=script&lang=js"
import style0 from "./UserProgressTracker.vue?vue&type=style&index=0&id=722b9e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "722b9e48",
  null
  
)

export default component.exports